module.exports = __webpack_public_path__ + "img/77.dec01868.jpg";